import React from 'react';
import { Flex } from 'rebass';
import Styled from 'styled-components';

import baseTheme from '../../themes/baseTheme';

const ViewContainerOuter = Styled(Flex)`
border-bottom: ${baseTheme.border};
padding: ${baseTheme.space[4]}px ${baseTheme.space[3]}px;
width: 100%;
margin-top: 100px;

`;

class ViewContainer extends React.Component {
  render() {
    return <ViewContainerOuter {...this.props}>{this.props.children}</ViewContainerOuter>;
  }
}

export default ViewContainer;
